<template>
  <v-card class="mx-auto" :color="color" dark max-width="400">
    <v-card-title>
      <!-- <v-icon large left>people</v-icon> -->
      <i :class="icon" style="margin-right:8px"></i>
      <span class="title font-weight-light">{{level1.title}}</span>
    </v-card-title>

    <div v-for="(l2, i2) in level1.childs" :key="i2">
      <v-divider></v-divider>
      <span class="level2-title">{{l2.title}}:</span>

      <v-list-tile class="grow" v-for="(p, ip) in l2.people" :key="ip">
        <v-list-tile-avatar color="white">
          <v-img v-if="p.avatar" class="elevation-6" :src="p.avatar"></v-img>
          <v-img v-if="!p.avatar && p.sexo == 'm'" class="elevation-6" src="/images/avatar-m.svg"></v-img>
          <v-img v-if="!p.avatar && p.sexo == 'f'" class="elevation-6" src="/images/avatar-f.svg"></v-img>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>
            <span class="people-name">{{p.name}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <br>
    </div>
    <br>
  </v-card>
</template>

<script>
import Banner3d from "../../components/banner/Equipe.vue";

export default {
  props: ["level1", "color", "icon"],
  data: () => ({
    equipe: null
  }),
  components: {
    Banner3d
  },
  created: function() {}
};
</script>

<style lang="scss" scoped>
p {
  text-align: left !important;
  font-weight: bold;
}

.level2-title {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.5);
  display: block;
  padding: 10px 0 5px 0px;
  margin: 0px 0 0 15px;
}

.people-name {
  color: white;
}
</style>
